import React from 'react';
import { Link } from 'react-router-dom';
import './css/hero.css';

export default function HeroBanner() {
  return (
    <section className="heroContainer home-hero1">
      <div className="heroWrapper">
        <div className="heroLeft">
          <h1 className="heroTitle">Minimize Your Tax Liability</h1>
          <p className="heroCopy">
            TaxObey guides businesses and individuals through tax compliance, planning, and
            filing so that your liability stays low and your records stay clean.
          </p>
          <div className="heroActions">
            <Link className="heroButton primary" to="/tax-services">Get Started Now</Link>
            <Link className="heroButton secondary" to="/about">Learn More →</Link>
          </div>
        </div>
      </div>
    </section>
  );
}
